import classNames from 'classnames';
import { useTheme } from '../../contexts/ThemeContext';

export default function GlassButton({
  children,
  variant = 'primary',
  size = 'md',
  href,
  onClick,
  className = '',
  icon,
  iconPosition = 'right',
  target,
  rel
}) {
  const { darkMode } = useTheme();
  const baseClasses = 'glass-button inline-flex items-center justify-center font-semibold rounded-full transition-all duration-300';

  const variantClasses = {
    primary: 'bg-main hover:bg-main2 text-white',
    secondary: 'bg-main-orange hover:bg-orange-600 text-white',
    ghost: darkMode
      ? 'bg-transparent border border-white/20 text-white hover:bg-white/10'
      : 'bg-transparent border-2 border-main text-main hover:bg-main/10',
    outline: 'bg-transparent border-2 border-main text-main hover:bg-main hover:text-white'
  };

  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };

  const classes = classNames(
    baseClasses,
    variantClasses[variant],
    sizeClasses[size],
    className
  );

  const content = (
    <>
      {icon && iconPosition === 'left' && <span className="mr-2">{icon}</span>}
      {children}
      {icon && iconPosition === 'right' && <span className="ml-2">{icon}</span>}
    </>
  );

  if (href) {
    return (
      <a 
        href={href} 
        className={classes} 
        target={target || "_blank"} 
        rel={rel || "noopener noreferrer"}
        onClick={onClick}
      >
        {content}
      </a>
    );
  }

  return (
    <button onClick={onClick} className={classes}>
      {content}
    </button>
  );
}
